export default {
  "content": "<path fill=\"#fff\" d=\"M14 9.3l13 7.4v15l-13 7.6-13-7.5v-15l13-7.6zM3 17.9v12.7l11 6.3 11-6.3V17.9l-11-6.3-11 6.3zM0 15l13-7.5V0h-2v6.3L0 12.8V15zm0 18.5L13 41v8h-2v-6.9L0 35.9v-2.3zM15 0v7.5L28 15v-2.3L17 6.4V0h-2zm0 49v-8l13-7.5v2.3l-11 6.4V49h-2z\" opacity=\".2\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "28",
    "height": "49",
    "fill": "none",
    "viewBox": "0 0 28 49"
  }
};